export function getPopups(state) {
  return state.popup.popups;
}
